import React from 'react';
import { Avatar, Box } from '@mui/material';

// 気分・感情のピクトグラムアイコン
export const FeelingIcons = {
  '罪悪感': {
    emoji: '😔',
    color: '#E57373',
    gradient: 'linear-gradient(135deg, #E57373, #EF5350)',
  },
  '虚無感': {
    emoji: '😶‍🌫️',
    color: '#90A4AE',
    gradient: 'linear-gradient(135deg, #90A4AE, #78909C)',
  },
  '特になし': {
    emoji: '😐',
    color: '#BDBDBD',
    gradient: 'linear-gradient(135deg, #BDBDBD, #9E9E9E)',
  },
  '満足': {
    emoji: '😌',
    color: '#81C784',
    gradient: 'linear-gradient(135deg, #81C784, #66BB6A)',
  },
  '前向き': {
    emoji: '😄',
    color: '#4FC3F7',
    gradient: 'linear-gradient(135deg, #4FC3F7, #29B6F6)',
  },
  'その他': {
    emoji: '🤔',
    color: '#9575CD',
    gradient: 'linear-gradient(135deg, #9575CD, #7E57C2)',
  },
};

// コンテンツタイプのピクトグラムアイコン
export const ContentTypeIcons = {
  '音声': {
    emoji: '🎵',
    color: '#FF8A65',
    gradient: 'linear-gradient(135deg, #FF8A65, #FF7043)',
  },
  '映像': {
    emoji: '🎥',
    color: '#4DB6AC',
    gradient: 'linear-gradient(135deg, #4DB6AC, #26A69A)',
  },
  '画像': {
    emoji: '🖼️',
    color: '#F06292',
    gradient: 'linear-gradient(135deg, #F06292, #EC407A)',
  },
  '文章': {
    emoji: '📝',
    color: '#FFD54F',
    gradient: 'linear-gradient(135deg, #FFD54F, #FFCA28)',
  },
  'ツール': {
    emoji: '🔧',
    color: '#A1887F',
    gradient: 'linear-gradient(135deg, #A1887F, #8D6E63)',
  },
  'パートナー': {
    emoji: '👥',
    color: '#90CAF9',
    gradient: 'linear-gradient(135deg, #90CAF9, #64B5F6)',
  },
  '妄想': {
    emoji: '💭',
    color: '#AED581',
    gradient: 'linear-gradient(135deg, #AED581, #9CCC65)',
  },
  'なし': {
    emoji: '❌',
    color: '#B0BEC5',
    gradient: 'linear-gradient(135deg, #B0BEC5, #90A4AE)',
  },
  'その他': {
    emoji: '✨',
    color: '#CE93D8',
    gradient: 'linear-gradient(135deg, #CE93D8, #BA68C8)',
  },
};

// アイコンコンポーネント
export function IconAvatar({ type, value, size = 40, showGradient = true }) {
  const icons = type === 'feeling' ? FeelingIcons : ContentTypeIcons;
  const iconData = icons[value] || icons['その他'];
  
  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        background: showGradient ? iconData.gradient : iconData.color,
        fontSize: size * 0.5,
        fontWeight: 'bold',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        border: '2px solid rgba(255, 255, 255, 0.3)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          transform: 'scale(1.1) rotate(5deg)',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
        },
      }}
    >
      {iconData.emoji}
    </Avatar>
  );
}

// 小さなインラインアイコン
export function InlineIcon({ type, value, size = 20 }) {
  const icons = type === 'feeling' ? FeelingIcons : ContentTypeIcons;
  const iconData = icons[value] || icons['その他'];
  
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        fontSize: size * 0.7,
        mr: 0.5,
      }}
    >
      {iconData.emoji}
    </Box>
  );
}

// アニメーション付きロードingアイコン
export function LoadingIcon({ size = 40 }) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: 'linear-gradient(45deg, #66BB6A, #42A5F5, #EC407A)',
        backgroundSize: '300% 300%',
        animation: 'gradientShift 2s ease infinite',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: size * 0.5,
        '@keyframes gradientShift': {
          '0%': { backgroundPosition: '0% 50%' },
          '50%': { backgroundPosition: '100% 50%' },
          '100%': { backgroundPosition: '0% 50%' },
        },
      }}
    >
      ⏳
    </Box>
  );
}

// 成功アイコン
export function SuccessIcon({ size = 40 }) {
  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        background: 'linear-gradient(135deg, #4CAF50, #66BB6A)',
        fontSize: size * 0.6,
        animation: 'bounceIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
        '@keyframes bounceIn': {
          '0%': { transform: 'scale(0)', opacity: 0 },
          '50%': { transform: 'scale(1.2)', opacity: 0.8 },
          '100%': { transform: 'scale(1)', opacity: 1 },
        },
      }}
    >
      ✅
    </Avatar>
  );
}

export default {
  FeelingIcons,
  ContentTypeIcons,
  IconAvatar,
  InlineIcon,
  LoadingIcon,
  SuccessIcon,
};